module.exports = __webpack_public_path__ + "fbb07154384cf94ddff0d6323b29cbf8.svg";